export default __webpack_public_path__ + "static/medtronic-a021db42ae708316ba1a469f491996ca.svg";